module.exports = __webpack_public_path__ + "media/assets/images/layout/bg_500-text-36f17838f70df2c18871aeeb85fcf20f.png";